import React, { useRef } from "react";
import { Box } from "@mui/material";
import { classNamesList } from "../../utils/class-name";

import "./style.scss";

interface IFileDragUploadProps {
    children: React.ReactNode;
    acceptedFiles: string;
    className?: string;
    isDragging: boolean;
    disableOnClick: boolean;
    onFileUploaded: (file: File) => void;
}

export const FileDragUpload = (props: IFileDragUploadProps) => {
    const fileUploadInputRef = useRef<HTMLInputElement | null>(null);

    const handleLabelFileDrop = (e: React.DragEvent) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files?.[0];
        if (droppedFile) {
            props.onFileUploaded(droppedFile);
        }
    };

    const handleLabelFileChange = () => {
        if (fileUploadInputRef.current?.files) {
            props.onFileUploaded(fileUploadInputRef.current.files[0]);
        }
    };

    const handleLabelButtonClick = () => {
        if (props.disableOnClick) {
            return;
        }

        fileUploadInputRef?.current?.click();
    };

    const handleLabelFileDragOver = (e: React.DragEvent) => {
        e.preventDefault();
    };

    return <Box onDrop={handleLabelFileDrop} onDragOver={handleLabelFileDragOver} onClick={handleLabelButtonClick}
                className={classNamesList([props.className, props.isDragging ? "file-upload-drag" : ""])}
                sx={{ position: "relative", zIndex: 262 }}>
        <input hidden ref={fileUploadInputRef} type={"file"} onChange={handleLabelFileChange} accept={props.acceptedFiles} />
        {props.children}
    </Box>;
};
